import React from "react";
import { Button, Col, FormLabel, FormSelect, Modal } from "react-bootstrap";
import { usePost } from "../../api";

interface Props {
  onClose: () => void;
  show: boolean;
}

export const DeleteTasksModal: React.FC<Props> = ({ onClose, show }) => {
  const [includeAllActivities, setIncludeAllActivities] = React.useState(true);
  const [forTheLastDays, setForTheLastDays] = React.useState(30);
  const deleteTasks = usePost<boolean>();

  const days1 = 1;
  const days2 = 2;
  const days7 = 7;
  const days30 = 30;
  const days60 = 60;
  const days90 = 90;

  const onDelete = async () => {
    await deleteTasks.execute(
      `/tasks/delete?includeActivities=${includeAllActivities}&days=${forTheLastDays}`
    );
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Old Tasks</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          This will permanently delete tasks and their associated data from the
          database.
        </p>

        <div className="mb-4">
          <FormLabel>Include All Activities</FormLabel>
          <FormSelect
            className="mb-3"
            value={includeAllActivities ? "yes" : "no"}
            onChange={(e) => setIncludeAllActivities(e.target.value === "yes")}
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </FormSelect>

          <FormLabel>Data from (Days)</FormLabel>
          <FormSelect
            value={forTheLastDays.toString()}
            onChange={(e) => setForTheLastDays(parseInt(e.target.value))}
          >
            <option value={days1}>{days1}</option>
            <option value={days2}>{days2}</option>
            <option value={days7}>{days7}</option>
            <option value={days30}>{days30}</option>
            <option value={days60}>{days60}</option>
            <option value={days90}>{days90}</option>
          </FormSelect>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
